
import { apiRequest } from "../api/request";
import API_PATHS from "../api/paths";

export async function runSimulator(data) {
    return await apiRequest({
        url: API_PATHS.simulate,
        method: "POST",
        data
    });
}